module.exports = __webpack_public_path__ + "img/header_img8.88001320.png";